import { render, staticRenderFns } from "./LayersDetail.vue?vue&type=template&id=0ebddc4c"
import script from "./LayersDetail.vue?vue&type=script&lang=js"
export * from "./LayersDetail.vue?vue&type=script&lang=js"
import style0 from "./LayersDetail.vue?vue&type=style&index=0&id=0ebddc4c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports